<div class="modal-header">
  <h5 class="modal-title">Add Case Overview Item</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <form autocomplete="off" (ngSubmit)="addItem()" [formGroup]="form">
    
    <div class="mb-3">
      <label class="form-label">Text</label>
      <textarea class="form-control" 
                formControlName="text" 
                rows="10"></textarea>
    </div>

  </form>
</div>

<div class="modal-footer">

  <button *ngIf="!isLoading" 
          type="button" 
          class="btn btn-success" 
          (click)="addItem()">
    Save
  </button>

  <button *ngIf="isLoading" 
          type="button" 
          class="btn btn-success" 
          disabled>
    <span class="spinner-border spinner-border-sm me-2"></span>
    Saving...
  </button>
</div>